import React from 'react'
import { useSelector } from 'react-redux'
import { buyedPointsStyle as styles } from '../../purchaseHistory.tailwind';
import BuyedPoints from './BuyedPoints';
import NoDataFound from '../../NoDataFound';
import Spinner from '../../../shared/Loaders/Spinner';

const BuyedPointsListingPage = ({ fromDate, toDate }) => {
  const { buyedPoints, pointsLoading } = useSelector((state) => state.purchaseHistory);
  const pointsToBeMapped = buyedPoints?.purchasedPoints;
  
  if (pointsLoading) {
    return (
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {pointsToBeMapped?.length > 0 ? (
          <BuyedPoints fromDate={fromDate} toDate={toDate} />
        ) : (
          <NoDataFound isToken={false} />
      )}
    </>
  )
}

export default BuyedPointsListingPage